import React from 'react';
import { Stack, Typography } from '@mui/material';
import { AccordionWithServiceCallNumber } from './AccordionWithServiceCallNumber';
import { AccordionWithClientContractNumber } from './AccordionWithClientContractNumber/AccordionWithClientContractNumber';
import { useIntl } from 'react-intl';

export const FindServiceCallSection = () => {
  const { formatMessage } = useIntl();
  const [expanded, setExpanded] = React.useState<number>(1);

  const handleChange =
    (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : 0);
    };

  return(
    <Stack gap={2}>
      <Stack>
        <Typography variant='h6'>{formatMessage({ id: 'FindServiceCall.Title', defaultMessage: 'Already have a ticket number?' })}</Typography>
        <Typography variant='body2' color='text.secondary'>{formatMessage({ id: 'FindServiceCall.Subtitle', defaultMessage: 'Track your request by completing the following information.' })}</Typography>
      </Stack>

      <Stack gap={1}>
        <AccordionWithServiceCallNumber expanded={expanded === 1} onChange={handleChange(1)} />
        <AccordionWithClientContractNumber expanded={expanded === 2} onChange={handleChange(2)} />
      </Stack>
    </Stack>
  );
};